import { c as _c } from "react/compiler-runtime";
import { CheckboxGroup as AriaCheckboxGroup, FieldError, Label, Text } from 'react-aria-components';
import { HelpText } from '~/components/HelpText';
import styles from './CheckboxGroup.module.css';
import type { CheckboxGroupProps } from './CheckboxGroup.types';
export function CheckboxGroup(t0) {
  const $ = _c(23);
  let children;
  let description;
  let errorMessage;
  let helpText;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      description,
      errorMessage,
      children,
      helpText,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = description;
    $[3] = errorMessage;
    $[4] = helpText;
    $[5] = label;
    $[6] = props;
  } else {
    children = $[1];
    description = $[2];
    errorMessage = $[3];
    helpText = $[4];
    label = $[5];
    props = $[6];
  }
  let t1;
  if ($[7] !== label) {
    t1 = label && <Label className={styles.label}>{label}</Label>;
    $[7] = label;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== helpText || $[10] !== label) {
    t2 = helpText ? <HelpText id={`${label}-help-text`}>{helpText}</HelpText> : null;
    $[9] = helpText;
    $[10] = label;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== description) {
    t3 = description && <Text slot="description">{description}</Text>;
    $[12] = description;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== errorMessage) {
    t4 = <FieldError className={styles.fieldError}>{errorMessage}</FieldError>;
    $[14] = errorMessage;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== children || $[17] !== props || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t5 = <AriaCheckboxGroup className={styles.checkboxGroup} {...props}>{t1}{t2}{children}{t3}{t4}</AriaCheckboxGroup>;
    $[16] = children;
    $[17] = props;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}